module.exports = `${require.publicPath}logo-login.90dc64df.png`;